// Webpack Imports
import * as bootstrap from 'bootstrap';

import "jquery-ui/ui/widgets/datepicker"
import "jquery-ui/ui/i18n/datepicker-es"

( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );


	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );

	document.addEventListener("DOMContentLoaded", function () {
		var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
		var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
			// Verificar si el atributo title no está vacío
			var title = tooltipTriggerEl.getAttribute('data-bs-title');
			if (title && title.trim() !== "") {
				return new bootstrap.Tooltip(tooltipTriggerEl);
			}
			return null; // No inicializar tooltips sin título
		}).filter(Boolean); // Filtrar los valores nulos

		const photoGallery = document.querySelector("#photoGallery");
		const pauseButton = document.querySelector("#carousel-pause-button");
		if (photoGallery && pauseButton) {
			const carousel = bootstrap.Carousel.getOrCreateInstance(photoGallery);
			const icon = pauseButton.querySelector("i");
			let isPaused = false;

			const updateIndicatorColors = (activeItem) => {
				const colorElement = activeItem.querySelector("[data-indicator-color]");
				const color = colorElement ? colorElement.dataset.indicatorColor : "#13284C";
				const isLight = color.toLowerCase() === "#ffffff" || color.toLowerCase() === "#fff";
				const arrowFilter = isLight ? "none" : "brightness(0) saturate(100%) invert(12%) sepia(25%) saturate(2000%) hue-rotate(190deg) brightness(95%) contrast(95%)";
				photoGallery.style.setProperty("--indicator-color", color);
				photoGallery.style.setProperty("--carousel-arrow-filter", arrowFilter);
			};

			const initialActive = photoGallery.querySelector(".carousel-item.active");
			if (initialActive) {
				updateIndicatorColors(initialActive);
			}

			photoGallery.addEventListener("slid.bs.carousel", function (event) {
				updateIndicatorColors(event.relatedTarget);
				if (isPaused) {
					setTimeout(function () {
						carousel.pause();
					}, 0);
				}
			});

			pauseButton.addEventListener("click", function () {
				if (isPaused) {
					carousel.cycle();
					isPaused = false;
					icon.classList.remove("fa-play");
					icon.classList.add("fa-pause");
				} else {
					carousel.pause();
					isPaused = true;
					icon.classList.remove("fa-pause");
					icon.classList.add("fa-play");
				}
			});
		}
    });
} )();